import React, { Fragment } from "react";

import { Container } from "../../components";
import { lazyWithRetry } from "../../core/lazy_with_retry";
import { Spacer } from "../spacer";
import { OfferingDetailsMultiPass } from "../template_offering_details_multipass";
import { Text } from "../text";
import { useTheMalinAnalytics } from "./themalin_analytics";
import { faqs, generalInfo, partnerConfig } from "./themalin_partner_config";

const Theme = lazyWithRetry(() => import("./themalin_theme"));

export function OfferingTheMalinMultiPass() {
  useTheMalinAnalytics();

  return (
    <Fragment>
      <Theme />
      <OfferingDetailsMultiPass
        showAddress={false}
        showDirections
        partnerConfig={partnerConfig}
        data={{
          title: `Multi Day Pass to The Malin Soho`,
          description: (
            <Container>
              <Text>
                Full access to The Malin’s communal areas with mixed seating,
                bookable spaces, and amenities at a discounted rate.
              </Text>
              <Spacer size={16} />
            </Container>
          ),
          faqs: faqs,
          generalInfo: generalInfo,
        }}
      />
    </Fragment>
  );
}
